import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableMobilePickingManualItemConfirmation = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableMobilePickingManualItemConfirmation);
};
